(() => {
  if (window.kickoffInitialized) return;
  window.kickoffInitialized = true;
  const updateContactOrder = form => {
    const field = form.querySelector('[data-ko-order-field]');
    if (!field) return;
    const topic = form.querySelector('input[name="contact[Anliegen]"]:checked')?.value;
    const show = topic === 'Meine Bestellung' || topic === 'Retoure';
    field.hidden = !show;
    field.querySelector('input').disabled = !show;
  };
  document.querySelectorAll('.ko-contact-form').forEach(updateContactOrder);
  document.addEventListener('change', event => {
    if (event.target.matches('input[name="contact[Anliegen]"]')) updateContactOrder(event.target.closest('form'));
  });
  let privacyScript;
  const openPrivacy = async () => {
    if (!window.privacyBanner?.showPreferences) {
      privacyScript ||= new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = 'https://cdn.shopify.com/shopifycloud/privacy-banner/storefront-banner.js';
        script.onload = resolve;
        script.onerror = reject;
        document.head.append(script);
      });
      await privacyScript;
    }
    await window.privacyBanner.showPreferences();
  };
  document.addEventListener('click', event => {
    if (!event.target.closest('[data-ko-privacy]')) return;
    const feedback = document.querySelector('[data-ko-privacy-feedback]');
    if (feedback) feedback.hidden = true;
    openPrivacy().catch(() => {
      if (feedback) {
        feedback.textContent = 'Die Cookie-Einstellungen konnten nicht geladen werden. Bitte lade die Seite neu oder kontaktiere uns unter info@kickoffclo.com.';
        feedback.hidden = false;
      }
    });
  });
  let lastDialogTrigger;
  const closeMenu = () => {
    document.getElementById('ko-navigation')?.classList.remove('is-open');
    const toggle = document.querySelector('.ko-mobile-toggle');
    toggle?.setAttribute('aria-expanded', 'false');
    toggle?.setAttribute('aria-label', 'Menü öffnen');
  };
  document.addEventListener('pointerdown', event => {
    if (!event.target.closest('.ko-header-shell')) {
      closeMenu();
      document.querySelectorAll('.ko-header-shell details[open]').forEach(details => details.open = false);
    }
  });
  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-ko-open]');
    if (opener) {
      const dialog = document.getElementById(opener.dataset.koOpen);
      if (dialog && !dialog.open) { lastDialogTrigger = opener; dialog.showModal(); }
    }
    const closer = event.target.closest('[data-ko-close]');
    if (closer) { closer.closest('dialog')?.close(); lastDialogTrigger?.focus(); }
    if (event.target.matches('dialog') && event.target.open) {
      const box = event.target.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) event.target.close();
    }
    const menu = event.target.closest('.ko-mobile-toggle');
    if (menu) { const open = menu.getAttribute('aria-expanded') !== 'true'; menu.setAttribute('aria-expanded', String(open)); menu.setAttribute('aria-label', open ? 'Menü schließen' : 'Menü öffnen'); document.getElementById('ko-navigation')?.classList.toggle('is-open', open); }
    const filter = event.target.closest('[data-ko-filter]');
    if (filter) {
      const section = filter.closest('.ko-lineup');
      section.querySelectorAll('[data-ko-filter]').forEach(button => { const active = button === filter; button.classList.toggle('is-active', active); button.setAttribute('aria-pressed', String(active)); });
      section.querySelectorAll('[data-ko-lineup-panel]').forEach(panel => { panel.hidden = panel.dataset.koLineupPanel !== filter.dataset.koFilter; });
    }
    const reviews = event.target.closest('[data-ko-reviews-more]');
    if (reviews) {
      const expanded = reviews.closest('.ko-reviews').classList.toggle('is-expanded');
      reviews.setAttribute('aria-expanded', String(expanded));
      reviews.innerHTML = expanded ? 'WENIGER ANZEIGEN <span>−</span>' : 'ALLE 30 BEWERTUNGEN LESEN <span>+</span>';
    }
    document.querySelectorAll('.ko-clubs[open],.ko-localization[open]').forEach(details => { if (!details.contains(event.target)) details.open = false; });
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.ko-clubs[open],.ko-localization[open]').forEach(details => details.open = false);
    const nav = document.getElementById('ko-navigation');
    if (nav?.classList.contains('is-open')) { closeMenu(); document.querySelector('.ko-mobile-toggle')?.focus(); }
  });
  document.addEventListener('cart:update', event => {
    const count = event.detail?.data?.itemCount ?? event.detail?.data?.item_count;
    if (Number.isFinite(count)) document.querySelectorAll('[data-ko-cart-count]').forEach(el => el.textContent = count);
  });
})();
